import { Card, Stack, Text } from "@/components/ui";
import type { SolicitudDetalle } from "@/lib/types";
import { useAuthStore } from "@/lib/auth-store";
import { esEstadoTerminal } from "@/features/solicitud-detalle/utils/estado-flags";
import { BannerOrganizacion } from "./BannerOrganizacion";
import { ReglasRechazadasAlert } from "./ReglasRechazadasAlert";
import { CfdiAusenteCard } from "./CfdiAusenteCard";
import { ResumenAccordion } from "./ResumenAccordion";

/** Tab Resumen · banner org + errores reglas + CFDI ausente + accordion. */
export function ResumenTab({ sol }: { sol: SolicitudDetalle }) {
  const user = useAuthStore((s) => s.user);
  const esDueno = user?.id === sol.solicitanteId;
  const terminal = esEstadoTerminal(sol.estado);
  // En estados terminales (p. ej. CanceladaPorSolicitante) no invitamos a cargar CFDI.
  // "Cargar CFDI" navega a un paso del wizard exclusivo del dueño (403 para
  // cualquier otro viewer) · Mesa de Control ve TODAS las solicitudes (P29).
  const mostrarCfdiAusente = !sol.cfdi && !terminal && esDueno;
  const tieneDatos = !!(
    sol.contratoAnualizado || sol.datosGenerales || sol.proveedor || sol.cfdi
  );

  return (
    <Stack gap="md">
      {sol.organizacion && (
        <div id="sec-organizacion">
          <BannerOrganizacion org={sol.organizacion} />
        </div>
      )}
      <ReglasRechazadasAlert errores={sol.erroresReglas} solicitudId={sol.id} numeroSolicitud={sol.numeroSolicitud} />
      {mostrarCfdiAusente && <CfdiAusenteCard solicitudId={sol.id} />}
      <ResumenAccordion sol={sol} />
      {/* Terminal sin datos capturados (se canceló temprano) · deja claro que no
          es un error, simplemente no alcanzó a capturarse información. */}
      {terminal && !tieneDatos && (
        <Card>
          <Text size="sm" c="dimmed">
            Esta solicitud no avanzó lo suficiente para capturar datos (contrato,
            CFDI, proveedor o prorrateo) antes de cerrarse. No hay más detalles que
            mostrar.
          </Text>
        </Card>
      )}
    </Stack>
  );
}
